/*
All parameters should be in snake_case
*/

export enum UploadSource {
  EDITOR = 'editor',
  SETTINGS = 'settings',
}

export type SnippetsUploadedEventProps = {
  count: number;
  source: UploadSource;
};

export type ReplacementsUploadedEventProps = {
  count: number;
  source: UploadSource;
};
